import React from 'react';
import red from '@material-ui/core/colors/red';
import TextField from '@material-ui/core/TextField';
import { ValidatorComponent } from 'react-form-validator-core';

const red300 = red['500'];

const style = {
    right: 0,
    fontSize: '12px',
    color: red300,
};

export default class TextFieldValidator extends ValidatorComponent {
    renderValidatorComponent() {
        const {
            error,
            errorMessages,
            validators,
            requiredError,
            validatorListener,
            withRequiredValidator,
            containerProps,
            ...rest
        } = this.props;
        const { isValid } = this.state;
        return (
            <div>
                <TextField
                    {...rest}
                />
                {this.errorText()}
            </div>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div style={style}>
                {this.getErrorMessage()}
            </div>
        );
    }
}
